export default __webpack_public_path__ + "static/media/M1A_9.c3945ca5.png";